module.exports = __webpack_public_path__ + "static/media/1014026.f99c67b6.png";